var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"padding":"40px"}},[_c('h5',[_c('b',[_vm._v("LIST OF AMEND CHANGES")])]),_c('hr'),_c('TableStockoutChangesIndex',{attrs:{"fields":_vm.fields.fields,"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }